import { OPEN_COMPLIANCE_MODAL, CLOSE_COMPLIANCE_MODAL } from "Constants/redux";

const INITIAL_STATE = {
  newTermContent: "",
  open: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case OPEN_COMPLIANCE_MODAL:
      return {
        ...state,
        newTermContent: action.payload.newTermContent,
        open: true
      };
    case CLOSE_COMPLIANCE_MODAL:
      return {
        ...state,
        open: false
      };
    default:
      return state;
  }
};
